import { Link } from "react-router-dom";
import { makeStyles } from "tss-react/mui";
import { MiConfigLogo } from "@miplatform/assets";
import { Box } from "@mui/material";

const useStyles = makeStyles()(() => ({
  rootContainer: {
    cursor: "pointer",
  },
}));

export const MiConfigHeaderLogo = () => {
  const { classes } = useStyles();

  return (
    <Box className={classes.rootContainer} component={Link} to="/config">
      <img src={MiConfigLogo} alt="MiConfig Logo" />
    </Box>
  );
};
